import ProjectSocketModel from 'models/sockets/project-socket-model';
import { handleActions } from 'redux-actions';
import {
  initProjectSocketIOSocketClient,
  initProjectSignalrSocketClient,
  setProjectSocketClient,
  clearProjectSocketClientInStore,
  stopProjectSocketConnection,
} from 'store/actions/project-socket-actions';
import { setProjectSocketDisconnectAction } from 'store/actions/action-creators';
import { initialProjectSocketClientUrl } from 'api/project-socket-client-api';

export default handleActions(
  {
    [initProjectSocketIOSocketClient]: (projectSocket, { payload }) => {
      const { projectId, geoCode, dispatch, currentUser } = payload;
      return projectSocket.init({ projectId, geoCode, dispatch, currentUser });
    },
    [initProjectSignalrSocketClient]: (projectSocket, { payload }) => {
      const { projectId, geoCode, dispatch } = payload;
      const url = initialProjectSocketClientUrl(projectId);
      return projectSocket.init({ url, geoCode, dispatch });
    },
    [setProjectSocketClient]: (projectSocket, { payload }) => {
      return projectSocket.setProjectSocketClients(payload);
    },
    [setProjectSocketDisconnectAction]: (projectSocket, { payload }) => {
      return projectSocket.setProjectSocketDisconnect(payload);
    },
    [stopProjectSocketConnection]: (projectSocket) => {
      return projectSocket.stopProjectSocketConnection();
    },
    [clearProjectSocketClientInStore]: () => {
      return new ProjectSocketModel();
    },
  },
  new ProjectSocketModel(),
);
